class UrlHelper {
  /**
   * Retorna a URL base
   * @returns {string}
   */
  getBaseUrl() {
    return document.location.protocol +"//"+ process.env.VUE_APP_API_HOST
  }

  /**
   * Retorna caminho concatenado da URL base
   * @param path
   * @returns {string}
   */
  url(path) {
    return this.getBaseUrl() + "/" + path;
  }
}

export default new UrlHelper();
